// Template consumed at deploy time by .github/workflows/build-deploy.yml (sed placeholder
// replacement — same pattern as document-service-frontend's cd.yml). Copied to
// environment.{gh-environment}.ts, placeholders replaced from GitHub Actions secrets scoped to
// the target GitHub Environment (aws-die / aws-silver / aws-gold / aws-prod), then compiled in
// via the matching angular.json fileReplacements configuration.
export const environment = {
	useProxy: false,
	production: true,
	msalConfig: {
		auth: {
			clientId: '8d7f64aa-f50d-4905-85f5-037fa577a194',
			authority: 'https://login.microsoftonline.com/3f998017-0d99-4e9a-ae46-fb070d03b2cc',
			redirectUri: 'https://frontend.beproductcatalogdie.alzp.tgscloud.net/auth-callback'
		}
	},
	apiConfig: {
		scopes: ['api://8d7f64aa-f50d-4905-85f5-037fa577a194/ProductCatalog.Admin.All'],
		uri: 'https://graph.microsoft.com/v1.0/me'
	}
};

